export default __webpack_public_path__ + "1967b55b1992fde10bab3750c714e130.png";